import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { findAllDatasets } from '../../state/shared';

const handleDatasetSubscribeSuccess = (draft, { code, subscriptions }) => {
  findAllDatasets(draft, { items: [{ code }] }).forEach((category) => {
    const item = findResult(draft.datasets, category, code);
    item.subscriptions = subscriptions;
    item.subscriptionsStatus = states.SUCCESS;
    item.subscriptionsErrors = [];
  });
};

export default handleDatasetSubscribeSuccess;
